import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";

import { faturamento1 } from "../../services/api";

import './detalhamento_bolsa.css';

const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio'];

const unidades_sigla = ['', 'BR', 'MD', 'SC', 'CD', 'TQ', 'NP', 'NI', '', 'SP', 'BT', 'CG', 'CP', 'MG', 'MC', 'IG', 'FG', 'RB'];

// ---------- Formatação (equivalente aos NumberFormat do Google Charts) ----------

const numeroBR = (v) =>
    v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// prefix "R$", negativeParens: true
const formatMoeda = (v) => {
    const texto = 'R$' + numeroBR(Math.abs(v));
    return v < 0 ? `(${texto})` : texto;
};

// suffix " %"
const formatPct = (v) => numeroBR(v) + ' %';

// ---------- Cores (equivalente aos ColorFormat do Google Charts) ----------
// No Google Charts o range é [de, até) — "de" inclusivo, "até" exclusivo.

// negativeColor: "red"
const estiloMoeda = (v) => (v < 0 ? { color: 'red' } : {});

// Colunas T27 (azul) e T26 (vermelho): [0, 20000, cor, "white"]
const estiloAlunos = (v, cor) =>
    v >= 0 && v < 20000 ? { color: cor, backgroundColor: 'white' } : {};

// Colunas A% e Fa%: [0, 20000, "white", "green"] e [-2000, 0, "white", "red"]
const estiloVariacao = (v) => {
    if (v >= 0 && v < 20000) return { color: 'white', backgroundColor: 'green' };
    if (v >= -2000 && v < 0) return { color: 'white', backgroundColor: 'red' };
    return {};
};

const calcVariacao = (atual, anterior) => {
    const v = ((atual * 100) / anterior) - 100;
    return Number.isFinite(v) ? v : 0;
};

const estiloCabecalho = { backgroundColor: '#e8e8e8', whiteSpace: 'nowrap' };

const Faturamento_estimado = (props) => {

    const [data2, setData2] = useState([]);

    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const meu_perfil = perfil[0].perfil;

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await faturamento1(data_inicio, data_fim);
            console.log("response faturamento1", response);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    // ---------- Montagem das linhas ----------
    let linhas = [];
    let total = null;

    if (Array.isArray(data2)) {
        let Ta26 = 0;
        let Ta27 = 0;
        let Tfat26 = 0.0;
        let Tfat27 = 0.0;

        linhas = data2.map((item) => {
            const a26 = parseInt(item.total_matriculas_26 || 0);
            const a27 = parseInt(item.total_matriculas_27 || 0);
            const fat26 = parseFloat(item.anuidade_ajustada_esperada_26 || 0);
            const fat27 = parseFloat(item.anuidade_ajustada_esperada_27 || 0);

            Ta26 += a26;
            Ta27 += a27;
            Tfat26 += fat26;
            Tfat27 += fat27;

            return {
                unidade: unidades[parseInt(item.sec)] || '',
                a27,
                fat27,
                a26,
                fat26,
                varAluno: calcVariacao(a27, a26),
                varFat: calcVariacao(fat27, fat26),
            };
        });

        // Ordena pelo nome da unidade (o chartData.sort() original fazia isso)
        linhas.sort((x, y) => x.unidade.localeCompare(y.unidade, 'pt-BR'));

        total = {
            unidade: 'TOTAL',
            a27: Ta27,
            fat27: Tfat27,
            a26: Ta26,
            fat26: Tfat26,
            varAluno: calcVariacao(Ta27, Ta26),
            varFat: calcVariacao(Tfat27, Tfat26),
        };
    }

    const renderLinha = (l, key, negrito = false) => (
        <tr key={key} style={negrito ? { fontWeight: 'bold' } : undefined}>
            <td>{l.unidade}</td>
            <td className="text-end" style={estiloAlunos(l.a27, 'blue')}>{l.a27}</td>
            <td className="text-end" style={estiloMoeda(l.fat27)}>{formatMoeda(l.fat27)}</td>
            <td className="text-end" style={estiloAlunos(l.a26, 'red')}>{l.a26}</td>
            <td className="text-end" style={estiloMoeda(l.fat26)}>{formatMoeda(l.fat26)}</td>
            <td className="text-end" style={estiloVariacao(l.varAluno)}>{formatPct(l.varAluno)}</td>
            <td className="text-end" style={estiloVariacao(l.varFat)}>{formatPct(l.varFat)}</td>
        </tr>
    );

    if (meu_perfil.startsWith("GESTOR")) {

        return (
            <div className="fatur">
                Alunos e Faturamento estimado.
                {/* Sem "striped"/"hover": no Bootstrap 5 eles pintam por cima das cores das células */}
                <Table bordered size="sm" responsive className="mb-0">
                    <thead>
                        <tr>
                            <th style={estiloCabecalho}>Unidade</th>
                            <th style={estiloCabecalho} className="text-end">T27</th>
                            <th style={estiloCabecalho} className="text-end">Fa27</th>
                            <th style={estiloCabecalho} className="text-end">T26</th>
                            <th style={estiloCabecalho} className="text-end">Fa26</th>
                            <th style={estiloCabecalho} className="text-end">A%</th>
                            <th style={estiloCabecalho} className="text-end">Fa%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {linhas.map((l, i) => renderLinha(l, i))}
                        {total && renderLinha(total, 'total', true)}
                    </tbody>
                </Table>
            </div>
        );

    } else {
        return (
            <div className="vazio">
            </div>
        );
    }
};

export default Faturamento_estimado;
